import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingService from "@app/overviews/network-benchmarking-dashboard/benchmarkingService";
import { MedicareNetwork } from "@app/overviews/network-benchmarking-dashboard/medicare/filters";
import { MedicarePrimaryFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/medicare/filters/shared/MedicarePrimaryFiltersPayload";

export interface MedicareContractDetailsResult {
  contractDetails: MedicareNetwork | undefined;
  isLoading: boolean;
}

export const MEDICARE_CONTRACT_DETAILS_QUERY_KEY_PREFIX = "benchmarking-medicare-contract";

export const useMedicareContractDetails = (
  contractId: string | undefined,
  versionId: number | undefined,
  displayedPrimaryFilters: MedicarePrimaryFiltersPayload
): MedicareContractDetailsResult => {
  const benchmarkingService = useMemo(() => new BenchmarkingService(), []);

  const queryResult = useQuery<MedicareNetwork>({
    enabled: !!contractId && !!displayedPrimaryFilters,
    queryFn: ({ signal }) => benchmarkingService.getContractDetails(contractId, displayedPrimaryFilters, versionId, signal),
    queryKey: [MEDICARE_CONTRACT_DETAILS_QUERY_KEY_PREFIX, contractId, versionId, JSON.stringify(displayedPrimaryFilters)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    contractDetails: queryResult.data,
    isLoading: queryResult.isFetching,
  };
}

export default useMedicareContractDetails;
